/* eslint-disable max-params */
import { createSelector } from 'reselect';
import {
  routeParamsSelector,
  queryParamsSelector,
} from 'shared/app/state/selectors/routes';
import { isCoreAppUrlSelector } from 'shared/app/state/selectors/locales';
import getReturnUrl from 'shared/universal/get-return-url';
import { getBaseUrl } from 'shared/app/utils/redirect-to-signin-with-return-url';
import { getUrlHostname } from '../../utils/get-url-hostname';

export const userSubmarketStateSelector = (state) =>
  state.accountSignin?.error?.userSubmarket ?? {};

const getBaseUrlSelector = () => getBaseUrl();

export const userSubmarketSelector = createSelector(
  userSubmarketStateSelector,
  isCoreAppUrlSelector,
  queryParamsSelector,
  getBaseUrlSelector,
  (userSubmarket, isCoreAppUrl, queryParams, currentBaseUrl) => {
    const baseUrl = isCoreAppUrl
      ? userSubmarket?.pwaRedirectUrl
      : userSubmarket?.legacyRedirectUrl;

    if (!baseUrl) return null;

    const currentBaseUrlHostname = getUrlHostname(currentBaseUrl);
    const redirectUrlHostname = getUrlHostname(baseUrl);
    const caseInsensitiveReturnUrl = getReturnUrl(queryParams);

    const returnUrl =
      caseInsensitiveReturnUrl && currentBaseUrlHostname && redirectUrlHostname
        ? caseInsensitiveReturnUrl.replace(
            currentBaseUrlHostname,
            redirectUrlHostname
          )
        : null;

    const redirectUrl = `${baseUrl}${
      returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : ''
    }`;

    return {
      ...userSubmarket,
      redirectUrl,
    };
  }
);

export const resetPasswordTokenSelector = createSelector(
  routeParamsSelector,
  (routeParams) => {
    const { token } = routeParams;
    return token;
  }
);

export const showKeepMeSignedInCheckboxSelector = (state) =>
  state.config?.showKeepMeSignedInCheckbox ?? false;
